require('../src/includes/blocks/tours/tours-filter/tours-filter.js');
require('../src/includes/blocks/catalog/catalog.js');



// WEBPACK FOOTER //
// ./libs/components.js